import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Card, Icon, List, Menu } from 'semantic-ui-react';
import PageContainer from '../common/PageContainer';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import AddSiteDialog from './AddSiteDialog';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';

export const AdminOrganization = ({ sites, loadAdminData }) => {
  useEffect(() => {
    loadAdminData();
  }, []);

  return (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>Admin</Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>Sites</Breadcrumb.Section>
      </Breadcrumb>

      <Menu borderless>
        <Menu.Item header>
          <Icon name="computer" />
          Sites
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <AddSiteDialog />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Card fluid>
        <Card.Content>
          <List selection verticalAlign="middle" divided>
            {sites.map(site => (
              <List.Item key={site.id}>
                <Link to={'/admin/site/' + site.id}>
                  <List.Content>
                    <List.Icon name="computer" />
                    {site.property} ({site.city})
                  </List.Content>
                </Link>
              </List.Item>
            ))}
          </List>
        </Card.Content>
      </Card>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  sites: selectors.getSites(state),
});

const mapDispatchToProps = dispatch => ({
  loadAdminData: bindActionCreators(actions.admin.loadAdminData, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminOrganization);
